import { useCallback, useEffect, useState, useMemo } from 'react'
import BigNumber from 'bignumber.js'
import { provider } from 'web3-core'

// utils
import { getAllowance, getContract } from '../../utils/bakery/erc20'
import { userExchangeNFTContract } from '../../userType/userExchangeNFTContract'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '..'
import useInterval from '../useInterval'
import { userTokenAddress } from '../../userType/userTokenAddress'
import { userV3NFTContract } from '../../userType/userV3NFTContract'

const useAllowanceERC20 = (type?: string, tokenName?: string) => {
  const [allowance, setAllowance] = useState(new BigNumber(0))
  const {account, library} = useActiveWeb3React()
  const ethereum = library?.provider
  const sushi = useYam()
  let lpTokenAddress = userTokenAddress(sushi, tokenName)
  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
  }, [ethereum, lpTokenAddress])

  let contract:any
  if(type && MARKETTYPE.hasOwnProperty(type)){
    contract = userBidNFTContract(sushi, type)
  }else if(type && MARKETMULTITOKEN.hasOwnProperty(type)){
    contract = multiTokenExchangeNftContract(sushi, type)
  }else if(type && MARKETTYPEV1.hasOwnProperty(type)){
    contract = userExchangeNFTContract(sushi, type)
  }else if(type && MARKETTYPEV3.hasOwnProperty(type)){
    contract = userV3NFTContract(sushi, type)
  }

  const fetchAllowance = useCallback(async () => {
    if (account) {
      const allowance = await getAllowance(
        lpContract,
        contract,
        account,
      )
      setAllowance(new BigNumber(allowance))
    }
  }, [account, contract, lpContract])

  useEffect(() => {
    if (account && contract && lpContract) {
      fetchAllowance()
    }
  }, [account, contract, lpContract, fetchAllowance])

  useInterval(fetchAllowance, !allowance.toNumber() ? 5000 : null)

  return allowance
}

export default useAllowanceERC20
